export default __webpack_public_path__ + "static/media/http-dark.916ae85f.svg";